import React, { memo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { HomeIcon, ActiveHomeIcon, SearchIcon, LibraryIcon } from '../../../Icons';
import { useAppDispatch, useAppSelector } from '../../../../store/store';
import { uiActions } from '../../../../store/slices/ui';

export const MobileMenu = memo(() => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();

  const isHome = location.pathname === '/';
  const isSearch = location.pathname.startsWith('/search') || location.pathname.startsWith('/browse');
  const isLibraryOpen = useAppSelector((state) => !state.ui.libraryCollapsed);

  return (
    <footer className='mobile-menu'>
      {/* 1. Home */}
      <button
        className={isHome ? 'active' : ''}
        onClick={() => {
          if (isLibraryOpen) dispatch(uiActions.collapseLibrary());
          navigate('/');
        }}
        aria-label='Home'
      >
        {isHome ? <ActiveHomeIcon /> : <HomeIcon />}
        <p>Home</p>
      </button>

      {/* 2. Search */}
      <button
        className={isSearch ? 'active' : ''}
        onClick={() => {
          if (isLibraryOpen) dispatch(uiActions.collapseLibrary());
          navigate('/search');
        }}
        aria-label='Search'
      >
        <SearchIcon style={{ fill: isSearch ? '#ffffff' : '#b3b3b3', stroke: isSearch ? '#ffffff' : 'none' }} />
        <p>Search</p>
      </button>

      {/* 3. Your Library */}
      <button
        className={isLibraryOpen ? 'active' : ''}
        onClick={() => dispatch(uiActions.toggleLibrary())}
        aria-label='Your Library'
      >
        <LibraryIcon />
        <p>Your Library</p>
      </button>
    </footer>
  );
});

MobileMenu.displayName = 'MobileMenu';

